import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { GraphList } from './GraphList';
import { GraphListTopBar } from './GraphListTopBar';
import { useGraphStorageApi } from '../api/useGraphStorageApi';

export type SortOption = 'updatedAt' | 'createdAt';

export const GraphListLayout: React.FC = () => {
    const { createGraph } = useGraphStorageApi();
    const navigate = useNavigate();
    const [sortBy, setSortBy] = useState<SortOption>('updatedAt');

    const createGraphWorkflow = async () => {
        const graphId = await createGraph({
            metadata: {
                name: 'Untitled Graph',
                description: '',
            },
            graph: {
                nodeInstances: [],
                connections: [],
                variables: [],
                functions: [],
            },
        });
        navigate(`/graph/${graphId}`);
    };

    return (
        <div className="bg-background min-h-screen max-h-screen grid grid-cols-1 grid-rows-[54px_calc(100vh-54px)]">
            <GraphListTopBar onCreateGraphClicked={createGraphWorkflow} sortBy={sortBy} onSortChange={setSortBy} />
            <div className="relative overflow-hidden">
                <GraphList sortBy={sortBy} onCreateGraph={createGraphWorkflow} />
            </div>
        </div>
    );
};
